import { useEffect } from 'react'

import { debounce } from 'es-toolkit/function'
import { useCommonStore } from 'shared/stores/commonStore'

import { useWindowStore } from '../stores'

const WINDOW_ASPECT_RATIO = 700 / 1000
const WINDOW_MAX_WIDTH = 1350
const WINDOW_MIN_WIDTH = 1000
const WINDOW_VERTICAL_OFFSET = 40
const SCREEN_WIDTH_COEFFICIENT = 0.52

export const useSetWindowSizes = () => {
  const updateAllWindowsSizes = useWindowStore(
    state => state.updateAllWindowsSizes
  )

  const topDockHeight = useCommonStore(state => state.topDockHeight)

  useEffect(() => {
    const handleResize = () => {
      const maxHeight =
        window.innerHeight - topDockHeight - WINDOW_VERTICAL_OFFSET * 2
      const minHeight = WINDOW_MIN_WIDTH * WINDOW_ASPECT_RATIO

      const widthByScreen = Math.min(
        WINDOW_MAX_WIDTH,
        Math.max(WINDOW_MIN_WIDTH, window.innerWidth * SCREEN_WIDTH_COEFFICIENT)
      )

      let width = widthByScreen
      let height = width * WINDOW_ASPECT_RATIO

      if (height > maxHeight) {
        height = maxHeight
        width = height / WINDOW_ASPECT_RATIO
      }

      if (height < minHeight) {
        height = minHeight
        width = height / WINDOW_ASPECT_RATIO
      }

      updateAllWindowsSizes({ width, height })
    }

    const debouncedHandleResize = debounce(handleResize, 150)

    handleResize()
    window.addEventListener('resize', debouncedHandleResize)

    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
      debouncedHandleResize.cancel()
    }
  }, [updateAllWindowsSizes, topDockHeight])
}
